import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import * as Styled from './ProgressTracker.styles';
import ProgressTrackerStep from './ProgressTrackerStep';

var ProgressTracker = function ProgressTracker(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Styled.Tracker, props, children);
};

ProgressTracker.displayName = 'ProgressTracker';
export { ProgressTracker, ProgressTrackerStep };